import { useMemo } from 'react'
import { Sport, UnitSystem } from '@frontend/core'
import { useAppSelector } from '../../store/hooks'
import { getUnitSystem } from '@frontend/core/lib/domains/units'
import { getSport } from '@frontend/core/lib/domains/sports'

export function useUnits() {
  const units = useAppSelector((state) => state.units)
  return units
}

export function useUnitsSystem(sport: Sport): UnitSystem {
  const unitsState = useUnits()
  const selectedSportType = useAppSelector(
    (state) => state.sports.selectedSportType
  )

  return useMemo(() => {
    return getUnitSystem(
      unitsState,
      sport.isUnknown() ? getSport(selectedSportType) : sport
    )
  }, [unitsState.selected, sport, selectedSportType])
}
